import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['children', 'icon']
  static values = { open: { type: Boolean, default: true } }

  toggle() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    this.childrenTarget.classList.toggle('grid-rows-[0fr]', !this.openValue)
    this.childrenTarget.classList.toggle('grid-rows-[1fr]', this.openValue)
    this.iconTarget.classList.toggle('rotate-180', !this.openValue)
  }
}
